<ng-container *ngIf="!!params">
    <tt-card>
        <tt-button-goto ttText="edit_customer" ttGoto="customeredit" [ttGotoParms]="{ cust_no: params.cust_no }"></tt-button-goto>
        <tt-button-goto ttText="persons" [ttBadge]="params.nbr_of_persons" ttGoto="customerpersons" [ttGotoParms]="{ cust_no: params.cust_no }"></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_button_orders === '1'"
            ttText="quotation_and_orders"
            [ttBadge]="params.nbr_of_orders"
            ttGoto="orderheads"
            [ttGotoParms]="{ argtype: 'cust_no', argvalue: params.cust_no }"
        ></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_invoices === '1'"
            ttText="customersmenu_invoices"
            [ttBadge]="params.nbr_of_invoices"
            ttGoto="invoiceheads"
            [ttGotoParms]="{ argtype: 'cust_no', argvalue: params.cust_no }"
        ></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_button_activities === '1'"
            ttText="activities"
            [ttBadge]="params.nbr_of_custacts"
            ttGoto="custactsearch"
            [ttGotoParms]="{ filterfield: 'cust_no', filtervalue: params.cust_no, custacttype: 'A' }"
        ></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_button_serviceobjects === '1'"
            ttText="customersmenu_serviceobjects"
            [ttBadge]="params.nbr_of_serviceobjects"
            ttGoto="serviceobjects"
            [ttGotoParms]="{ argtype: 'cust_no', argvalue: params.cust_no }"
        ></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_projects === '1'"
            ttText="customersmenu_projects"
            [ttBadge]="params.nbr_of_projects"
            ttGoto="projects"
            [ttGotoParms]="{ argtype: 'cust_no', argvalue: params.cust_no }"
        ></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_button_custactplanning === '1'"
            ttText="activityplanning"
            ttGoto="custactplanning"
            [ttGotoParms]="{ argtype: 'cust_no', argvalue: params.cust_no }"
        ></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_button_documents === '1'"
            ttText="documents"
            [ttBadge]="params.nbr_of_documents"
            ttGoto="documents"
            [ttGotoParms]="{ argtype: 'cust_no', argvalue: params.cust_no }"
        ></tt-button-goto>
    </tt-card>

    <tt-card>
        <tt-button-goto
            *ngIf="params.show_button_pictures === '1'"
            ttText="pictures"
            [ttBadge]="params.nbr_of_pictures"
            ttGoto="pictures"
            [ttGotoParms]="{ argtype: 'cust_no', argvalue: params.cust_no }"
        ></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_button_deviation === '1'"
            ttText="deviations"
            [ttBadge]="params.nbr_of_deviations"
            ttGoto="custactsearch"
            [ttGotoParms]="{ filterfield: 'cust_no', filtervalue: params.cust_no, custacttype: 'D' }"
        ></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_button_timeregister === '1'"
            ttText="time_stat"
            ttGoto="powtimegroup"
            [ttGotoParms]="{
                cust_no: params.cust_no,
                project_keyno: '0',
                projectprosess_keyno: '0',
                custact_no: '0',
                date_start: '2000-01-01',
                date_end: '2100-12-31',
                grouptype: 'Y',
                equipment_id: '-',
                labour_no: '0',
                prod_id: '-',
            }"
        ></tt-button-goto>
        <tt-button-goto ttText="map" (ttClick)="openLink(params.maplink)"></tt-button-goto>
        <tt-button-goto ttText="company_info" (ttClick)="openLink(params.weblink_economics)"></tt-button-goto>
        <tt-button-goto *ngIf="params.show_special_calc1 === '1'" ttText="special_cust_prod_calc" ttGoto="special_cust_prod_calc" [ttGotoParms]="{ cust_no: params.cust_no }"></tt-button-goto>
        <tt-button-goto *ngIf="params.show_customer_discgrpprod === '1'" ttText="customer_discgrpprod" ttGoto="customer_discgrpprod" [ttGotoParms]="{ cust_no: params.cust_no }"></tt-button-goto>
        <tt-button-goto *ngIf="params.show_button_customerclaims === '1'" ttText="goto_customer_claims" ttGoto="customerclaims" [ttGotoParms]="{ cust_no: params.cust_no }"></tt-button-goto>
        <tt-button-goto *ngIf="params.show_button_customerbonus === '1'" ttText="goto_customer_bonus" ttGoto="customerbonus" [ttGotoParms]="{ cust_no: params.cust_no }"></tt-button-goto>
    </tt-card>

    <tt-card>
        <tt-button-goto ttText="forms" ttGoto="checklistdatas" [ttGotoParms]="{ argtype: 'cust_no', argvalue: params.cust_no }"></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_purchprice === '1'"
            ttText="customersmenu_pricelistprice"
            [ttBadge]="params.nbr_of_purchprice"
            ttGoto="pricelistprice"
            [ttGotoParms]="{ argtype: 'supplier_no', argvalue: params.cust_no }"
        ></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_button_pricelistfactor === '1'"
            ttText="customersmenu_pricelistfactors"
            ttGoto="pricelistfactors"
            [ttGotoParms]="{ argtype: 'supplier_no', argvalue: params.cust_no }"
        ></tt-button-goto>
        <tt-button-goto ttText="customersmenu_purchases" ttGoto="purchheads" [ttGotoParms]="{ argtype: 'supplier_no', argvalue: params.cust_no }"></tt-button-goto>
        <tt-button-goto
            *ngIf="params.show_deliverycustomers === '1'"
            ttText="customersmenu_deliverycustomers"
            [ttBadge]="params.nbr_of_deliverycustomers"
            ttGoto="deliverycustomers"
            [ttGotoParms]="{ cust_no: params.cust_no }"
        ></tt-button-goto>
        <tt-button-goto *ngIf="params.show_button_map === '1'" ttText="customersmenu_mapview" ttGoto="mapview" [ttGotoParms]="{ argtype: 'cust_no', argvalue: params.cust_no }"></tt-button-goto>
        <tt-button-goto *ngIf="params.show_button_customer_edi === '1'" ttText="tt_customer_edi" ttGoto="edisetup" [ttGotoParms]="{ argtype: 'cust_no', argvalue: params.cust_no }"></tt-button-goto>
        <tt-button-goto ttText="customersmenu_custfacts" ttGoto="custfacts" [ttGotoParms]="{ cust_no: params.cust_no }"></tt-button-goto>
        <tt-button-goto
            *ngIf="+params.acc_supp_no > 0 && params.show_freightratesets === '1'"
            ttText="customersmenu_freightratesets"
            ttGoto="freightratesets"
            [ttGotoParms]="{ cust_no: params.cust_no }"
        ></tt-button-goto>
        <ng-container *ngIf="params.show_accounting_accounts === '1'">
            <tt-button-goto
                *ngIf="+params.acc_supp_no > 0"
                ttText="customersmenu_acsupptranses"
                [ttBadge]="params.acc_supp_no_saldo"
                ttGoto="acsupptranses"
                [ttGotoParms]="{ acc_supp_no: params.acc_supp_no }"
            ></tt-button-goto>
            <tt-button-goto
                *ngIf="+params.acc_cust_no > 0"
                ttText="customersmenu_accustranses"
                [ttBadge]="params.acc_cust_no_saldo"
                ttGoto="accusttranses"
                [ttGotoParms]="{ argtype: 'acc_cust_no', argvalue: params.acc_cust_no }"
            ></tt-button-goto>
        </ng-container>
        <tt-button ttText="customersmenu_delete" ttIcon="fas fa-trash-alt" ttType="danger" (ttClick)="deleteCustomer()" [ttLoading]="deleting"></tt-button>
        <tt-button-settings *ngIf="params.show_setting === '1'" ttWebpageName="customersmenu"></tt-button-settings>
    </tt-card>
</ng-container>
